export enum AVariableContext {
    Theme = 0,
    Database = 1,
    Core = 2,
    Bookkeeping = 3
}